import {
  BusinessChallengesEnum,
  OrganizationApplicationParameters,
} from '@platform/client/schemas';
import { FormsInputDropdown, FormsMultilineInput } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageProps } from '../../Application';
import { useApplicationLocalStorage } from '../../application-hook';
import { ApplicationBackground } from '../../ApplicationBackground';
import { ApplicationPageContent } from '../../components/ApplicationPageContent';
import BackgroundImage from '../../images/Leftsection8.svg';
import { challengeOptions } from './OrgFirstChallengeSelection';

type FormValues = {
  secondBusinessChallenge: BusinessChallengesEnum;
  secondBusinessChallengeDescription?: string;
};

export const OrgSecondChallengeSelection = (props: ApplicationPageProps) => {
  const { onBack, onContinue, progress, isEditProfile = false } = { ...props };

  const { updateApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<OrganizationApplicationParameters>();

  const {
    handleSubmit,
    formState: { errors },
    watch,
    control,
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      secondBusinessChallenge: getApplicationDataByKey('secondBusinessChallenge'),
      secondBusinessChallengeDescription: getApplicationDataByKey(
        'secondBusinessChallengeDescription',
      ),
    },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    updateApplicationData({
      secondBusinessChallenge: data.secondBusinessChallenge,
      secondBusinessChallengeDescription: data.secondBusinessChallengeDescription,
    });
    onContinue();
  };

  const handleBack = () => {
    updateApplicationData({
      secondBusinessChallenge: watch('secondBusinessChallenge'),
      secondBusinessChallengeDescription: watch('secondBusinessChallengeDescription'),
    });
    onBack();
  };

  return (
    <ApplicationBackground
      progress={progress}
      isOrganization={true}
      onBack={handleBack}
      onSubmit={handleSubmit(submit)}
      backgroundImage={BackgroundImage}
      isEditProfile={isEditProfile}
    >
      <ApplicationPageContent title='Tell us about your second biggest challenge'>
        <FormsInputDropdown
          control={control}
          name='secondBusinessChallenge'
          rules={{ required: 'Select a challenge your organization needs help with to continue' }}
          label='Second business challenge'
          placeholder='Select your second challenge'
          items={challengeOptions}
          type='default'
          error={errors.secondBusinessChallenge}
        />
        <FormsMultilineInput
          control={control}
          label='Tell us more about this challenge'
          placeholder='Enter a description...'
          name={'secondBusinessChallengeDescription'}
          rules={{ maxLength: 500, required: 'Tell us more about this challenge to continue' }}
          formsError={errors.secondBusinessChallengeDescription}
          characterCount={500}
        />
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
